import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Anchor",
  category: "common",
  icon: "admin-links",
  keywords: ["accordion"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/anchor", (props) => {
  return <div className="w-full float-left clear-both h-px opacity-0 block" id={props?.anchorId ?? ""} />
})
